import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import ServiceUKContent from "./section-components/service-uk-content";
import ServiceUKBoxes from "./section-components/service-uk-boxes";
import BlogSlider from "./blog-components/blog-slider-v1";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const ServiceUKPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="UK Freight" subheader="Services" />
      <ServiceUKContent />
      <ServiceUKBoxes />
      {/* <BlogSlider sectionClass="pt-120" /> */}
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default ServiceUKPage;
